module.exports = __webpack_public_path__ + "img/pr-10.0666a73f.png";